
export type TweetFeedResponseTweetsItemPoll = {
  /**
   * @minimum 5
   * @maximum 10080
   */
  durationMinutes: number;
  readonly endsAt?: string;
  /**
   * @minItems 2
   * @maxItems 4
   */
  options: string[];
};
